import PromoBYDAtto3 from "../../../images/promo/jan26/PromoBYDAtto3.png";
import PromoBYDAtto3Mobile from "../../../images/promo/jan26/PromoBYDAtto3Mobile.png";
import PromoMercedes from "../../../images/promo/jan26/PromoMercedes.png";
import PromoMercedesMobile from "../../../images/promo/jan26/PromoMercedesMobile.png";
import PromoPolestar from "../../../images/promo/jan26/PromoPolestar.png";
import PromoPolestarMobile from "../../../images/promo/jan26/PromoPolestarMobile.png";
import PromoChery from "../../../images/promo/jan26/PromoCherryE5.png";
import PromoCheryMobile from "../../../images/promo/jan26/PromoCherryE5Mobile.png";
import PromoTeslaY from "../../../images/promo/jan26/PromoTeslaY.png";
import PromoTeslaYMobile from "../../../images/promo/jan26/PromoTeslaYMobile.png";
import PromoZeekr from "../../../images/promo/jan26/PromoZeekr7.png";
import PromoZeekrMobile from "../../../images/promo/jan26/PromoZeekr7Mobile.png";
import PromoVolvoEX30 from "../../../images/promo/jan26/PromoVolvoEX30.png";
import PromoVolvoEX30Mobile from "../../../images/promo/jan26/PromoVolvoEX30Mobile.png";

const dataSlider = (hidePartnered) => [
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: true,
        hideBanner: hidePartnered, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "",
        image: "",
        imageMobile: "",
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, //true will remove this section from the slider
        titleBadge: "New Year Offer",
        vehicleTitle: "BYD Atto 3, Seal, Sealion 6, Sealion 7, Shark 6",
        vehicleSubTitle:
            "$3,000 cashback for eligible vehicle orders between 1st January to 31st January, and delivered by 28th February 2026!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available to eligible customers who order and take delivery within the promotional period. Cashback will be processed after settlement. Terms and eligibility criteria apply.",
        termsLinkUrl: "",
        image: PromoBYDAtto3,
        imageMobile: PromoBYDAtto3Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "New Year Offer",
        vehicleTitle: "Mercedes-Benz EQA 250+ and GLE & GLS models",
        vehicleSubTitle:
            "Upto $10,000 cash savings across models in addition to National Fleet discounts for vehicles ordered between 1st January and 28th February, and delivered by 31st March 2026!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available to eligible customers who order and take delivery within the promotional period. Terms and eligibility criteria apply.",
        termsLinkUrl: "",
        image: PromoMercedes,
        imageMobile: PromoMercedesMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "New Year Offer",
        vehicleTitle: "Polestar 2 & 4",
        vehicleSubTitle:
            "Upto 18% discounts on vehicles ordered between 1st January and 31st March 2026 or until stock runs out!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available to eligible customers who order and take delivery within the promotional period. Terms and eligibility criteria apply.",
        termsLinkUrl: "",
        image: PromoPolestar,
        imageMobile: PromoPolestarMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Exclusive Offer",
        vehicleTitle: "Chery E5 BEV & Chery Tiggo Urban & Ultimate models",
        vehicleSubTitle:
            "Exclusive to Novated Lease Australia Customers, all eligible orders from 1st January 2026 and delivered by 15th April 2026 receive $1,000 cashback from NLA in addition to vehicle discounts!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available to eligible customers who order and take delivery within the promotional period. Cashback will be processed after settlement. Terms and eligibility criteria apply.",
        termsLinkUrl: "",
        image: PromoChery,
        imageMobile: PromoCheryMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Customer Favourites",
        vehicleTitle: "Tesla Model Y RWD",
        vehicleSubTitle: "",
        priceDollar: "216",
        priceCents: "",
        period: "weekly*",
        disclaimerText:
            "* Weekly price assumes a 5 year lease, a driver based in NSW with an annual pre-tax salary of $100,000, and car running costs based on 15,000km driven per year.",
        termsLinkUrl: "",
        image: PromoTeslaY,
        imageMobile: PromoTeslaYMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Customer Favourites",
        vehicleTitle: "Zeekr 7X",
        vehicleSubTitle: "",
        priceDollar: "207",
        priceCents: "",
        period: "weekly*",
        disclaimerText:
            "* Weekly price assumes a 5 year lease, a driver based in NSW with an annual pre-tax salary of $100,000, and car running costs based on 15,000km driven per year",
        termsLinkUrl: "",
        image: PromoZeekr,
        imageMobile: PromoZeekrMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, //true will remove this section from the slider
        titleBadge: "Exclusive Discounts",
        vehicleTitle: "Volvo, all models",
        vehicleSubTitle:
            "Exclusive to Novated Lease Australia Customers, all Volvo Electric Vehicle orders to enjoy a minimum of $3,000 fleet discount, all Volvo Petrol/Hybrid Vehicles orders to enjoy a 10% discount on list price, PLUS 5 years free servicing!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available to eligible customers who order and take delivery within the stated promotion period. Discount applied to vehicle purchase price; servicing offer provided by manufacturer or dealer. Terms and eligibility criteria apply.",
        termsLinkUrl: "",
        image: PromoVolvoEX30,
        imageMobile: PromoVolvoEX30Mobile,
    },
];

export default dataSlider;
